export default [
  {
    title: 'Routing & Switching',
    workbooks: [
      {
        title: 'CCNP TSHOOT Workbook',
        link: 'https://workbooks.ine.com/CCNP+TSHOOT+Workbook.zip',
      },
      {
        title: 'CCNP Switch Workbook',
        link: 'https://workbooks.ine.com/CCNP+Switch+Workbook.zip',
      },
      {
        title: 'CCNP Route Workbook',
        link: 'https://workbooks.ine.com/CCNP+Route+Workbook.zip',
      },
      {
        title: 'CCNA Routing & Switching v3.0 ICND1 Workbook',
        link:
          'https://workbooks.ine.com/CCNA+Routing+%26+Switching+v3.0+ICND1+Workbook.zip',
      },
      {
        title: 'CCNA Routing & Switching Lab Workbook',
        link:
          'https://workbooks.ine.com/CCNA+Routing+%26+Switching+Lab+Workbook.zip',
      },
      {
        title: 'CCIE Routing & Switching v5 Lab Workbook',
        link:
          'https://workbooks.ine.com/CCIE+Routing+%26+Switching+v5+Lab+Workbook.zip',
      },
      {
        title: 'CCIE Routing & Switching Online Graded Lab #4',
        link:
          'https://workbooks.ine.com/CCIE+Routing+%26+Switching+Online+Graded+Lab+%234.zip',
      },
      {
        title: 'CCIE Routing & Switching Online Graded Lab #3',
        link:
          'https://workbooks.ine.com/CCIE+Routing+%26+Switching+Online+Graded+Lab+%233.zip',
      },
      {
        title: 'CCIE Routing & Switching Online Graded Lab #2',
        link:
          'https://workbooks.ine.com/CCIE+Routing+%26+Switching+Online+Graded+Lab+%232.zip',
      },
      {
        title: 'CCIE Routing & Switching Online Graded Lab #1',
        link:
          'https://workbooks.ine.com/CCIE+Routing+%26+Switching+Online+Graded+Lab+%231.zip',
      },
      {
        title:
          'CCIE Routing & Switching (v4) Volume II - Full-Scale Practice Labs (Online)',
        link:
          'https://workbooks.ine.com/CCIE+Routing+%26+Switching+(v4)+Volume+II+-+Full-Scale+Practice+Labs+(Online).zip',
      },
      {
        title:
          'CCIE Routing & Switching (v4) Volume I - Advanced Technology Labs (Online)',
        link:
          'https://workbooks.ine.com/CCIE+Routing+%26+Switching+(v4)+Volume+I+-+Advanced+Technology+Labs+(Online).zip',
      },
    ],
  },
  {
    title: 'Security',
    workbooks: [
      {
        title: 'CCIE Security v5 Bootcamp Workbook',
        link:
          'https://workbooks.ine.com/CCIE+Security+v5+Bootcamp+Workbook.zip',
      },
      {
        title: 'CCIE Security v4 Technologies Workbook',
        link:
          'https://workbooks.ine.com/CCIE+Security+v4+Technologies+Workbook.zip',
      },
      {
        title: 'CCIE Security v4 Practice Labs Workbook',
        link:
          'https://workbooks.ine.com/CCIE+Security+v4+Practice+Labs+Workbook.zip',
      },
    ],
  },
  {
    title: 'Service Provider',
    workbooks: [
      {
        title: 'CCIE Service Provider Lab Workbook v4 (Online)',
        link:
          'https://workbooks.ine.com/CCIE+Service+Provider+Lab+Workbook+v4+(Online).zip',
      },
      {
        title: 'CCIE Service Provider Lab Workbook v3 (Online)',
        link:
          'https://workbooks.ine.com/CCIE+Service+Provider+Lab+Workbook+v3+(Online).zip',
      },
    ],
  },
  {
    title: 'Data Center',
    workbooks: [
      {
        title: 'UCS Advanced Technology Labs',
        link: 'https://workbooks.ine.com/UCS+Advanced+Technology+Labs.zip',
      },
      {
        title: 'Nexus Advanced Technology Labs',
        link: 'https://workbooks.ine.com/Nexus+Advanced+Technology+Labs.zip',
      },
      {
        title: 'CCIE Data Center v2 Lab Workbook (beta)',
        link:
          'https://workbooks.ine.com/CCIE+Data+Center+v2+Lab+Workbook+(beta).zip',
      },
    ],
  },
  {
    title: 'Collaboration',
    workbooks: [
      {
        title: 'CCIE Collaboration Workbook',
        link: 'https://workbooks.ine.com/CCIE+Collaboration+Workbook.zip',
      },
    ],
  },
]
